import React, { useMemo }  from "react";

import RadioGroup from "../../common/radio-group/radio-group.component";
import useSelectedProduct from "../../componentHooks/useSelectedProduct";
import { IOT_PRODUCTS_LIST } from "../../constants/iot.products.constants";

const IOTProductList = ({productsList}) => {

    const { selectedProduct, setSelectedProduct } = useSelectedProduct();

    const productListOptions = useMemo( () => {
       return IOT_PRODUCTS_LIST.filter( ({ key }) => productsList.includes(key) );
    })
    

    return(
        <>
        
        <RadioGroup
              options={productListOptions}
              value={selectedProduct}
              getKey={(option) => option.key}
              onChange={(value) => setSelectedProduct(value)}
            />
         
        
        </>
    )

}

export default IOTProductList;
